import { createContext } from "react";
import {
  ExchangeMetadata,
  ExchangesMetadata,
  QueryStatus,
} from "@shared/types";

export const ExchangesMetadataContext = createContext<
  | {
      exchangesMetadata: ExchangesMetadata | undefined;
      getExchangesMetadataStatus: QueryStatus<ExchangesMetadata>;
      getExchangeMetadata: (exchange?: string) => ExchangeMetadata | undefined;
      getExchangePriceFactorLimits: (exchange?: string) => {
        min: number;
        max: number;
      };
      isSuccess?: boolean;
      getAlternativeUsdPairs: (accountId?: number) => string[] | undefined;
    }
  | undefined
>(undefined);
